/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_SaveInputs */

const en_views_save = /** @type {(inputs: Views_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save view`)
};

const de_views_save = /** @type {(inputs: Views_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansicht speichern`)
};

/**
* | output |
* | --- |
* | "Save view" |
*
* @param {Views_SaveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_save = /** @type {((inputs?: Views_SaveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_SaveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_save(inputs)
	return en_views_save(inputs)
});